module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_fails.js
// module id = 20
// module chunks = 1